<div class="app flex-row" style="margin-top: 100px">
  @switch (errorType) {
    @case ("expired-link") {
      <div class="row justify-content-center" style="padding-top: 100px">
        <div class="col-md-6 col-xl-4">
          <div class="card">
            <div class="card-body text-center">
              This document request link has expired. <br />
              Please contact us and request a new link.
            </div>
          </div>
        </div>
      </div>
    }
    @default {
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="clearfix">
              <h1 class="float-start display-3 me-4">404</h1>
              <h4 class="pt-3">Oops! You're lost.</h4>
              <div class="text-muted">
                The page you are looking for was not found.
              </div>
              <div class="text-muted">
                <a [routerLink]="['/']">Click here</a> to go back to the
                dashboard
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
